import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewReleases from "../pages/new-releases/page";
import Works from "../pages/works/page";
import WorkDetail from "../pages/work-detail/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/new-releases",
    element: <NewReleases />,
  },
  {
    path: "/works",
    element: <Works />,
  },
  {
    path: "/work/:id",
    element: <WorkDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;